<template>
  <v-menu offset-y v-model="menu" :nudge-width="nudgeWidth" :close-on-click="closeOnClick"
    :close-on-content-click="closeOnConentClick">
    <template #activator="{on}">
      <slot name="activator" :on="on">
        <v-btn color="primary" dark slot="activator" v-on="on">{{btnText}}</v-btn>
      </slot>
    </template>
    <v-card class="white" pa-1>
      <v-card-title primary-title v-if="title">
        <slot name="title" :tilte="title">
          {{title}}
        </slot>
      </v-card-title>
      <v-container grid-list-xs pa-3>
        <slot>
        </slot>
      </v-container>
      <v-card-actions style="background: white" v-show="showActions">
        <v-spacer></v-spacer>
        <v-btn flat @click="menu = false">取消</v-btn>
        <v-btn color="primary" flat @click="submit()" v-if="allowSubmit">确认</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<style scoped>

</style>

<script>
  import GhMenu from "./ghMenu.ts";
  export default GhMenu;
</script>